<template>
    <div class="container">
        <div class="common-header-wrap">
            <!-- <mt-header :title="$t('Promotion member')" class="common-header"> -->
            <mt-header :title="$t('GiftCard')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <mt-button slot="right" @click="openPicker">{{ $t('Data') }}</mt-button>
            </mt-header>
        </div>

        <!-- <div class="search">
            <input type="text" v-model="value" :placeholder="$t('Search')" @keyup.enter="handleEnter" />
        </div> -->

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="order-body" v-if="userList && userList.length">
                <div class="list" v-for="item in userList" :key="item.id">
                    <div @click="gotoDetail(item.id)">
                        <div class="tips-body">
                            <span class="tips">{{ $t('OrderNo') }}: {{ item.order_sn }}</span>
                            <span class="tips statusTips copy" @click.stop="copySuccess(item.order_sn)">
                                {{ $t('Copy') }}</span>
                        </div>

                        <div class="order-image">
                            <div class="goods_info clearfix">
                                <div class="goods_name">{{ item.title }}</div>
                                <div class="goods_price">
                                    <div class="price">${{ item.price }}</div>
                                    <div class="num">X{{ 1 }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="number-code">
                            <div class="nci">
                                <div class="tit">{{ $t('Card number') }}:
                                    <div class="cc">
                                        <div class="c">{{ item.card }}</div>
                                    </div>
                                </div>
                                <div class="copy" @click.stop="copySuccess(item.card)">copy</div>
                            </div>
                        </div> -->
                        <div class="order_amount">
                            <!-- {{ $t('Face Value Total') }}:
                            <i class="order_amount_icon">$</i>
                            <i class="i">{{ item.back_price }}</i> -->
                            {{
                                item.status == 1 ? $t('Verifying') :
                                item.status == 2 ? $t('Rebuying') :
                                    item.status == 3 ? $t('Repurchased') :
                                        item.status == 4 ? $t('Paid') : $t('Unknown')
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="userList && !userList.length"></empty-record>
        </div>

        <mt-datetime-picker ref="picker" type="date" :cancelText="$t('MessageBox.Cancel')"
            :confirmText="$t('MessageBox.Confirm')" v-model="pickerValue" :endDate="endDate_" @confirm="changeTime"
            @touchmove.native.stop.prevent>
        </mt-datetime-picker>
    </div>
</template>
  
<script>
import { getSearchGift } from '../../../api/memberInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
export default {
    name: 'MemberSearchGiftList',
    components: {
        EmptyRecord
    },
    data() {
        return {
            params: {
                'page': 0,
                'limit': 10,
                'date': '',
                member_id: this.$route.query.tmember_id ? this.$route.query.tmember_id : '',
            },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            userList: false,
            type: this.$route.query.type ? this.$route.query.type : 0,
            pickerValue: '',
            endDate: '',
            endDate_: new Date(),
            value: '',
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        gotoDetail(id) {
            return
            this.$router.push({ name: 'GiftBoxDetail', query: { order_id: id } })
        },
        copySuccess(sn) {
            this.$copyText(sn).then(
                (e) => {
                    Toast(this.$t('succ'))
                }, (e) => {
                    Toast(this.$t('err'))
                }
            );
        },
        handleEnter() {
            // if (!this.value) return
            this.params.member_name = this.value
            this.getUserList(false)
        },
        getUserList(ispush) {
            Indicator.open()
            let params = this.params
            getSearchGift(params).then(res => {
                Indicator.close()

                if (res.result.data) {
                    if (ispush && this.userList) {
                        this.userList = this.userList.concat(res.result.data)
                    } else {
                        this.userList = res.result.data
                    }

                    if (res.result.current_page !== res.result.last_page && res.result.total !== 0) {
                        this.isMore = true
                    } else {
                        this.isMore = false
                    }
                }
            })
        },
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getUserList(true)
            }
        },
        //打开时间选择器
        openPicker() {// 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.endDate) {
                this.pickerValue = this.endDate
            } else {
                this.pickerValue = new Date()
            }

            this.$refs.picker.open()
        },
        //时间选择器选中
        changeTime(value) {
            console.log(this.utils.formatDate_(value, 'yyyy-MM-dd'));		//自带的value就是选中的时间
            let date = this.utils.formatDate_(value, 'yyyy-MM-dd')
            this.params.date = date
            this.userList = []
            this.getUserList(false)

            this.endDate = value
        },
    }
}
</script>
  
<style scoped lang="scss">
.container {
    background: #f8f8f8;
    min-height: 100vh;
}

.search {
    margin: .5rem;

    input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        border-radius: 1.6rem;
        background-size: 0.55rem;
        font-size: 0.6rem;
        color: #999;
        background: #f4f4f4;
        padding-left: 1.6rem;
        border: 0;
    }
}

.inviter-item {
    display: flex;
    align-items: center;
    padding: .5rem;
    background: #fff;
    border-bottom: 1px solid #e4e4e4;

    .avatar {
        width: 4.5rem;

        img {
            width: 4rem
        }
    }

    .inviter {
        flex: 1;
        font-size: $subFontSize;

        .users {
            font-size: $h3;
            // margin-bottom: 1rem;
            // margin-top: .5rem
        }

        .time {
            color: gray;
            margin-top: .2rem
        }
    }
}

.order-body {
    position: relative;

    .list {
        width: 100%;
        margin-top: 0.5rem;

        .tips-body {
            height: 2.2rem;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
            display: flex;
            justify-content: space-between;
            padding: 0 0.75rem 0 0.5rem;

            .tips {
                font-size: .7rem;
                color: #333;
                line-height: 2.2rem;
            }

            .statusTips {
                color: $primaryColor;
            }

            .copy {
                font-weight: 600;
                margin: 0 0;
            }

            img {
                width: 3.8rem;
                height: 3rem;
            }
        }

        .order-image {
            // height: 4.55rem;
            background: rgba(250, 250, 250, 1);
            width: 100%;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;

            .goods_info {
                height: 3rem;
                display: flex;
                align-items: center;
                padding-left: $pageSpace;
                padding-right: $pageSpace;

                .img {
                    width: 3rem;
                    height: 3rem;
                    margin: .85rem .3rem .5rem;

                    img {
                        width: 3rem;
                        height: 3rem;
                        border-radius: 1px;
                    }
                }

                .goods_name {
                    white-space: normal;
                    overflow: hidden;
                    height: 2rem;
                    width: 10rem;
                    font-size: .7rem;
                    color: #333;
                }

                .goods_price {
                    margin-left: auto;
                    padding-right: .75rem;
                    text-align: right;

                    .price {
                        font-size: $subFontSize;
                        color: rgba(78, 84, 93, 1);
                    }

                    .num {
                        font-size: .6rem;
                        color: #999;
                        padding-top: .3rem;
                    }
                }
            }
        }

        .multiple {
            .imagebox {
                width: 100%;
                overflow-x: auto;
                white-space: nowrap;

                img {
                    width: 3rem;
                    height: 3rem;
                    margin: .85rem .3rem .5rem;
                    display: inline-block;
                }
            }
        }

        .number-code {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            background-color: #fff;

            .nci {
                height: 2rem;
                padding: 0 .75rem;
                border-bottom: 1px solid #e8eaed;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .tit {
                    margin-bottom: .1rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .cc {
                    padding: 0 .1rem;
                }

                .copy {
                    color: $primaryColor;
                    font-weight: 600;
                }
            }
        }

        .order_amount {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            line-height: 2.2rem;
            height: 2.2rem;
            background-color: #fff;
            padding: 0 0.5rem;
            border-bottom: 1px solid #e8eaed;
            box-sizing: border-box;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #FB2630;
            font-weight: 600;

            .order_amount_icon {
                font-size: $subFontSize;
                color: $primaryColor;
            }

            i {
                font-size: $h2;
                color: $primaryColor;
                padding-left: 0.15rem;
                font-style: normal;

                &.freight {
                    color: #333;
                    font-size: $fontSize;
                }
            }
        }
    }

    .loading-wrapper {
        text-align: center;

        p {
            color: #c3c3c3;
            font-size: $fontSize;
            margin: 0.5rem auto;
        }
    }
}
</style>
  